export default __webpack_public_path__ + "static/media/logoecosfron2.a8f3c6ff.png";